import TopNavbar from "../Navbar";
import { NavLink, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { LandingPageJson } from '../../Utils/Constants'
import { AppliedParentJson } from "../../redux/action";
import { useDispatch } from "react-redux";
import ErrorBoundary from "../../Components/ErrorBoundary";
import React, { useState } from "react";
import { LIVE_URL } from "../../env";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";
import './index.scss'
import { log_firebase_event } from "../..";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Search from "@mui/icons-material/Search";

export default function CategoryPage() {


    const [selectedValues, setSelectedValues] = useState([]);

    const handleChange = (event, newValue) => {
        const brandIds = newValue.map((option) => option.BrandID.toString())
        setSelectedValues(brandIds);
        console.log(brandIds);
    };


    const navigate = useNavigate()


    let [loader, setLoader] = useState(false)
    const [brandList, setBrandList] = useState([]);

    const [showImageSearch, setShowImageSearch] = useState(false)

    const dispatch = useDispatch();
    localStorage.setItem("IsGenderFilterOpen", 'False')
    const SetBasicJson = (ID) => {
        dispatch(
            AppliedParentJson({
                data: {
                    CategoryID: [],
                    SubCategoryID: [ID],
                    Gender: [],
                    ProductType: [],
                    BrandType: [],
                    BrandID: selectedValues,

                    Color: [],
                    SiteColorID: [],

                    FADMonth: [],
                    FADYear: [],
                    InwardYear: [],
                    InwardMonth: [],
                    LiveStyle: [],
                    CondiFinalSourcing1: [],
                    CondiFinalSourcing2: [],
                    StockType: [],
                    Vendors: [],
                    Ageing: [],
                    MRP: [],
                    _30daysRPT: [],
                    _30DaysST: [],
                    _90daysRPT: [],
                    _90DaysST: [],
                    topbottom: [],
                    SellingPrice: [],
                    Replainshment: [],
                    B2BMixPercent: [],
                    IndMargin: [],
                    Discount: [],
                    NGM: [],
                    StockCover: [],
                    SRPercent: [],
                    TotalIntakeBucket: [],
                    AgeFrom: [],
                    TotalB2CSoldQty: [],
                    CTR: [],
                    Potypes: [],
                    PoAttributes: [],
                    sort: 'TotalRPT',
                    order: 'DESC',
                    page: 1,
                    pagesize: 500
                }
            })
        );
        localStorage.setItem("JsonData", JSON.stringify({
            CategoryID: [],
            SubCategoryID: [ID],
            Gender: [],
            ProductType: [],
            BrandType: [],
            BrandID: selectedValues,

            Color: [],
            SiteColorID: [],

            FADMonth: [],
            FADYear: [],
            InwardYear: [],
            InwardMonth: [],
            LiveStyle: [],
            CondiFinalSourcing1: [],
            CondiFinalSourcing2: [],
            StockType: [],
            Vendors: [],
            Ageing: [],
            MRP: [],
            _30daysRPT: [],
            _30DaysST: [],
            _90daysRPT: [],
            _90DaysST: [],
            topbottom: [],
            SellingPrice: [],
            Replainshment: [],
            B2BMixPercent: [],
            IndMargin: [],
            Discount: [],
            NGM: [],
            StockCover: [],
            SRPercent: [],
            TotalIntakeBucket: [],
            AgeFrom: [],
            TotalB2CSoldQty: [],
            CTR: [],
            Potypes: [],
            PoAttributes: [],
            sort: 'TotalRPT',
            order: 'DESC',
            page: 1,
            pagesize: 500
        }))
    }


    const SetBasicJsonWithBrand = () => {
        dispatch(
            AppliedParentJson({
                data: {
                    CategoryID: [],
                    SubCategoryID: [],
                    Gender: [],
                    ProductType: [],
                    BrandType: [],
                    BrandID: selectedValues,

                    Color: [],
                    SiteColorID: [],

                    FADMonth: [],
                    FADYear: [],
                    InwardYear: [],
                    InwardMonth: [],
                    LiveStyle: [],
                    CondiFinalSourcing1: [],
                    CondiFinalSourcing2: [],
                    StockType: [],
                    Vendors: [],
                    Ageing: [],
                    MRP: [],
                    _30daysRPT: [],
                    _30DaysST: [],
                    _90daysRPT: [],
                    _90DaysST: [],
                    topbottom: [],
                    SellingPrice: [],
                    Replainshment: [],
                    B2BMixPercent: [],
                    IndMargin: [],
                    Discount: [],
                    NGM: [],
                    StockCover: [],
                    SRPercent: [],
                    TotalIntakeBucket: [],
                    AgeFrom: [],
                    TotalB2CSoldQty: [],
                    CTR: [],
                    Potypes: [],
                    PoAttributes: [],
                    sort: 'TotalRPT',
                    order: 'DESC',
                    page: 1,
                    pagesize: 500
                }
            })
        );
        localStorage.setItem("JsonData", JSON.stringify({
            CategoryID: [],
            SubCategoryID: [],
            Gender: [],
            ProductType: [],
            BrandType: [],
            BrandID: selectedValues,

            Color: [],
            SiteColorID: [],

            FADMonth: [],
            FADYear: [],
            InwardYear: [],
            InwardMonth: [],
            LiveStyle: [],
            CondiFinalSourcing1: [],
            CondiFinalSourcing2: [],
            StockType: [],
            Vendors: [],
            Ageing: [],
            MRP: [],
            _30daysRPT: [],
            _30DaysST: [],
            _90daysRPT: [],
            _90DaysST: [],
            topbottom: [],
            SellingPrice: [],
            Replainshment: [],
            B2BMixPercent: [],
            IndMargin: [],
            Discount: [],
            NGM: [],
            StockCover: [],
            SRPercent: [],
            TotalIntakeBucket: [],
            AgeFrom: [],
            TotalB2CSoldQty: [],
            CTR: [],
            Potypes: [],
            PoAttributes: [],
            sort: 'TotalRPT',
            order: 'DESC',
            page: 1,
            pagesize: 500
        }))
    }

    const GetBrandList = async () => {
        setLoader(true);
        let payload = {
            "page": 1,
            "pagesize": 2000,
            "keyName": "BrandName",
            "keyID": "BrandID",
            "username": localStorage.getItem("emailaddress")
        }

        let BrandTypeBaseUrl = LIVE_URL + 'commonFilters'

        await axios.post(BrandTypeBaseUrl, payload).then((response) => {
            if (response.status) {

                const sortedBrands = [...response.data.data];

                sortedBrands.sort((a, b) => {
                    let nameA = a.BrandName.toLowerCase().trim();
                    let nameB = b.BrandName.toLowerCase().trim();
                    return nameA.localeCompare(nameB);
                })

                setBrandList(sortedBrands)


            }
            setLoader(false);
        }).catch((err => {
            setLoader(false);
            console.log(err)
        }))
    }
    React.useEffect(() => {

        // log_firebase_event('landing_page', { user_email: localStorage.getItem('emailaddress') })
        log_firebase_event('screen_view', { firebase_screen: 'Category Landing' });


        setLoader(true);
        let wishlistUrl = LIVE_URL + 'shortlistprodlistbyuser';
        var payload = {
            "userid": localStorage.getItem('userid'),
            "page": 1,
            "pagesize": 1000
        };
        axios.post(wishlistUrl, payload)
            .then((response) => {
                if (response.status === 200) { // Assuming response.status indicates success
                    setLoader(false);
                    const styles = response.data.data.map((item) => item.style);
                    localStorage.setItem("LikedProducts", styles)
                } else {
                    setLoader(false);
                }
            })
            .catch(() => {
                setLoader(false);
            });

        GetBrandList()




    }, []);

    const compareOptions = (option, value) => option.BrandID === value.BrandID;


    const renderOption = (props, option) => {
        return (
            <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>

                <div>{option.BrandName}</div>
                <div style={{ fontWeight: '600' }}>{option.doc_count}</div>


            </li>
        );
    };


    return (<>
        <Loader status={loader} />
        <TopNavbar />
        <ErrorBoundary>
            {brandList.length > 0 &&

                <div style={{ display: 'flex', padding: '20px', alignItems: 'center', justifyContent: 'space-around', backgroundColor: 'rgba(154, 185, 187, 0.37)' }}>


                    <Autocomplete
                        sx={{ width: '85%' }}
                        multiple
                        // value={selectedValues}
                        onChange={handleChange}
                        getOptionLabel={(option) => option.BrandName}
                        options={brandList}
                        isOptionEqualToValue={compareOptions}
                        filterSelectedOptions

                        renderOption={renderOption}


                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Search Brands "
                                placeholder="enter brand name"
                            />
                        )}



                    />

                    <Button
                        style={{ marginLeft: '10px' }}
                        variant="contained"
                        size="large"
                        color="primary"
                        endIcon={<Search />}
                        onClick={() => {
                            navigate('/categoryproductlisting', { state: { CategoryId: "" } })
                            SetBasicJsonWithBrand()

                        }}
                    >Go</Button>

                </div>
            }

            <div style={{ textAlign: 'center', padding: '20px', backgroundColor: 'rgba(154, 185, 187, 0.37)' }}>


                <span className='zoom' style={{
                    fontFamily: 'initial', fontSize: '50px', color: 'darkslategray'
                }}>Categories</span>


                {/*
                <img alt="logo" style={{width: '-webkit-fill-available'}} src={require('../../categories.png')}/>
*/}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', backgroundColor: 'rgba(154, 185, 187, 0.37)' }}>
                <Container>
                    <Row>
                        {LandingPageJson.map((data => {
                            return (<Col className="p-2 d-flex flex-column justify-content-center align-content-center" style={{ maxWidth: '200px' }} key={data.id}>
                                <NavLink className='d-flex flex-column' style={{ all: 'unset' }} to="/categoryproductlisting" state={{ CategoryId: data.SubCategoryID }} onClick={(e) => { SetBasicJson(data.SubCategoryID) }}>
                                    <img className='zoom' alt="logo" style={{ height: '160px', width: '110px', cursor: 'pointer' }}
                                        src={data.SubImgName} />
                                    <div
                                        variant="outline-secondary" className='my-button'><span
                                            className="text-dark Landing-Page-Class">{data.SubCategoryName}</span></div>{' '}
                                </NavLink>
                            </Col>)
                        }))}
                    </Row>
                </Container>

            </div>
            {showImageSearch &&

                <div className="fab-imagesearch"
                    onClick={() => {
                        setShowImageSearch(true)
                    }}
                >
                    <i className="fa fa-camera" />
                    <span className="imagesearch-label">Image Search</span>

                </div>
            }


        </ErrorBoundary>

    </>)
}